import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useCustomer = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const searchCustomers = async (search, page = 1, limit = 5) => {
    const params = new URLSearchParams();
    if (search) params.append('search', String(search));
    params.append('page', String(page));
    params.append('limit', String(limit));
    return await sendRequest({
      url: `/api/v1/customer?${params.toString()}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  // Slim lookup for the create-booking customer form. Requires the dedicated
  // customer:special:bookingLookup right and returns only the fields needed to
  // fill the booking customer data.
  const lookupCustomersForBooking = async search => {
    const params = new URLSearchParams();
    if (search) params.append('search', String(search));
    return await sendRequest({
      url: `/api/v1/customer/bookingLookup?${params.toString()}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
      // Typing must never open the auth escalation modal for a suggestion request
      noAutoStore: true,
    });
  };

  return { searchCustomers, lookupCustomersForBooking };
};

export default useCustomer;
